import { post } from '@/api/core'

import { MemberMyInfoEditReq } from './types'

/**
 * 我的个人资料修改
 * @description https://api.yinnho.cn/api.php?do=member_my_info_edit&help
 * @param data 请求参数
 */
export function member_my_info_edit (data: MemberMyInfoEditReq) {
  return post('member_my_info_edit', data)
}
